// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button-right[data-v-5396133a] {\n  position: absolute;\n  right: 1em;\n}\n@media all and (max-width: 1199px) {\n.button-right[data-v-5396133a] {\n    position: relative;\n    right: 0;\n}\n}", ""]);
// Exports
module.exports = exports;
